import React from 'react';
import styles from './salesFlag.scss';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../types';
import { decodeHTML } from '../../../helpers/html-helper';

export const SalesFlag = inject('store')(
    observer(({ store }: IInjectedProps) => {
        const localization = store!.localization;
        const price = store?.dataStore.orderModule.flexSetPrice;
        const isSetPrice = true;
        // const isSetPrice = store?.mixedMediaStore.salesArticleType === 2;
        const { rrp, sale, setPrice, containsFreeArticle } = localization.generalL10n;
        const priceDeduction = -(price?.priceDeduction ?? 0);
        const hasFreeItems = store?.orderModuleStore.basketModalData.brickSelections.some(it => it.isFreeInSet);
        if (hasFreeItems) {
            return (
                <div data-testid='rrp-flag' data-semantic-id='rrp-flag' className={styles.info_flag}>
                    <span className={styles.label}>{decodeHTML(containsFreeArticle)}</span>
                </div>
            );
        }
        else if (price?.hasRecommendedRetailPrice && priceDeduction) {
            return (
                <div data-testid='rrp-flag' data-semantic-id='rrp-flag' className={styles.info_flag}>
                    <span className={styles.label}>{decodeHTML(rrp)}</span>
                    <span className={styles.percentage}>{priceDeduction.toFixed(0)}%</span>
                </div>
            );
        } else if (!price?.hasRecommendedRetailPrice) {
            return (
                <div data-testid='sales-flag' data-semantic-id='sales-flag' className={styles.info_flag}>
                    <span className={styles.label}>
                        {decodeHTML(!isSetPrice ? sale : setPrice)}
                    </span>
                    <span className={styles.percentage}>{priceDeduction.toFixed(0)}%</span>
                </div>
            );
        } else {
            return null;
        }
    })
);

